import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="pt-16 bg-white min-h-screen">
      {/* Page Title */}
      <div className="bg-white text-gray-800 py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#2b603e] to-[#1a3d25]">Privacy Policy</h1>
          <p className="text-xl max-w-3xl mx-auto text-gray-600">
            How Asclepius protects and manages your personal information.
          </p>
        </div>
      </div>

      {/* Divider */}
      <div className="container mx-auto px-4">
        <hr className="border-t border-gray-200 my-0" />
      </div>

      {/* Policy Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-8">
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Data Collection Purpose</h2>
              <p className="text-gray-600">
                Asclepius collects personal information solely to process orders and improve service.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Personal Data Collected</h2>
              <p className="text-gray-600">
                Personal data collected includes:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Name</li>
                <li>Address</li>
                <li>Email</li>
                <li>Phone number</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Data Usage and Storage</h2>
              <p className="text-gray-600">
                This data is stored securely and used only for order fulfillment and communication.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Data Sharing</h2>
              <p className="text-gray-600">
                Asclepius does not sell or share personal data with third parties, except trusted service providers needed for order processing (e.g., shipping companies).
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Customer Rights</h2>
              <p className="text-gray-600">
                Customers have the right to:
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Access their personal data</li>
                <li>Correct their personal data</li>
                <li>Request deletion of their personal data</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Cookies and Tracking</h2>
              <p className="text-gray-600">
                Cookies may be used on the website to enhance user experience but do not store sensitive information.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Legal Compliance</h2>
              <p className="text-gray-600">
                Asclepius complies with Dutch and EU data protection laws (GDPR).
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Consent</h2>
              <p className="text-gray-600">
                By using Asclepius' website, customers consent to this privacy policy.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Information</h2>
              <p className="text-gray-600">
                For questions or requests regarding personal data, contact Asclepius at:
                <br />
                <strong>Email:</strong> info@asclepius-shilajit.com
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy; 